import './App.css';
import Head from './components/Head/Head';
import JapBody from './components/JapBody/JapBody'

function App() {
  return (
    <div className="App">
      <Head/>
      <JapBody/>
    </div>
  );
}

export default App;
